import { toSafeString } from '@shared/utils';

/**
 * One tool result can produce several generated files. Each becomes its own
 * artifact preview item, and they all share the seq of the tool result event.
 * This tells the live upsert that two such items are siblings, not two versions
 * of the same event, so the seq fallback does not overwrite one with the other.
 */
const isSiblingArtifactPreview = ({ existingEvent, incomingEvent }) => {
  if (existingEvent?.type !== 'artifactPreview' || incomingEvent?.type !== 'artifactPreview') {
    return false;
  }

  if (toSafeString(existingEvent?.id) === toSafeString(incomingEvent?.id)) {
    return false;
  }

  return toSafeString(existingEvent?.artifactId) !== toSafeString(incomingEvent?.artifactId);
};

export default isSiblingArtifactPreview;
